module.exports = __webpack_public_path__ + "static/media/so-algo-pig1.0abc5b04.jpg";